import IncedentBlack from "./incidentBlack";
export default IncedentBlack;